// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12a4d6d7","239":"271f695b","455":"e6c4a1f9"}[chunkId] + ".chunk.js";
};